import 'owl.carousel2/dist/assets/owl.carousel.css';
import $ from 'jquery';
import 'owl.carousel2/dist/owl.carousel.min';

$(function () {
    const $banners = $('.banners-owl-carousel');
    if ($banners.length) {
        $banners.owlCarousel({
            loop: true,
            nav: true,
            responsiveClass: true,
            margin:40,
            responsive: {
                1200: {
                    items: 4,
                    nav: true,
                    loop: true,
                },
                1024: {
                    items: 3,
                    nav: true,
                    loop: true,
                },
                640: {
                    items: 2,
                    nav: true,
                    loop: true,
                },
                0: {
                    items: 1,
                    nav: true,
                    loop: true,
                },

            },
        });
    }
});



// WEBPACK FOOTER //
// ./js/common/carousel.js